import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useOrdenPedidoStore } from '../store/ordenPedidoStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'default'> = { APR: 'success', PEN: 'warning', ANU: 'error', ENT: 'success' };
const estadoLabels: Record<string, string> = { APR: 'Aprobada', PEN: 'Pendiente', ANU: 'Anulada', ENT: 'Entregada' };

export const OrdenesPedidoPage: React.FC = () => {
  const navigate = useNavigate();
  const { ordenes, loading, fetchOrdenes } = useOrdenPedidoStore();

  useEffect(() => { fetchOrdenes(); }, [fetchOrdenes]);

  const columns: GridColDef[] = [
    { field: 'numero', headerName: 'Número', width: 120 },
    { field: 'fechaPedido', headerName: 'Fecha Pedido', width: 120, valueFormatter: (value: string) => { try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } } },
    { field: 'persona', headerName: 'Cliente', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.personaContacto || '-' },
    { field: 'vendedor', headerName: 'Vendedor', width: 150, valueGetter: (value: any) => value?.usuario || '-' },
    { field: 'total', headerName: 'Total', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    { field: 'estado', headerName: 'Estado', width: 120, renderCell: (params) => <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" /> },
    { field: 'fechaEntrega', headerName: 'Fecha Entrega', width: 120, valueFormatter: (value: string) => { if (!value) return '-'; try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } } },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Órdenes de Pedido</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/ventas/ordenes-pedido/nueva')}>Nueva Orden</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid rows={ordenes} columns={columns} getRowId={(row) => row.idOrdenPedido} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/ventas/ordenes-pedido/${params.row.idOrdenPedido}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
